import { c as _c } from "react/compiler-runtime";
import { MAX_HISTORY_ITEMS } from "@domainstack/constants";
import { Skeleton } from "@domainstack/ui/skeleton";
import { cn } from "@domainstack/ui/utils";
export function HomeSearchSuggestionsSkeleton(t0) {
  const $ = _c(10);
  const {
    className,
    count: t1
  } = t0;
  const count = t1 === undefined ? MAX_HISTORY_ITEMS : t1;
  let t2;
  if ($[0] !== count) {
    t2 = Array.from({
      length: count
    }, _temp);
    $[0] = count;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const skeletonItems = t2;
  let t3;
  if ($[2] !== className) {
    t3 = cn("relative", className);
    $[2] = className;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== skeletonItems) {
    t4 = <div className="overflow-hidden py-0.5"><div className="flex gap-2 pl-0.5">{skeletonItems.map(_temp2)}</div></div>;
    $[4] = skeletonItems;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="pointer-events-none absolute top-0 right-0 h-full w-12 bg-gradient-to-l from-background to-transparent" />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t3 || $[8] !== t4) {
    t6 = <div className={t3} aria-hidden="true">{t4}{t5}</div>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}
function _temp2(item) {
  return <div key={item.id} className="flex h-8 shrink-0 items-center gap-2 rounded-md border-none bg-muted/40 px-2.5 ring-1 ring-ring/20"><Skeleton className="size-4 rounded-sm" /><Skeleton className="h-3.5" style={{
      width: `${item.width}px`
    }} /></div>;
}
function _temp(_, itemNumber) {
  return {
    id: `home-search-suggestion-skeleton-${itemNumber}`,
    width: 80 + itemNumber * 20 % 60
  };
}